import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sk_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const PRACTITIONER = {
  name: "Sudiksha Kulharia",
  title: "Psychologist & Counsellor",
  email: "sudikshakulharia1@gmail.com",
  phone: "+91 87968 03360",
  whatsapp: "918796803360", // for wa.me link (no + sign)
  instagram: "sud.psych.talks",
  instagramUrl: "https://instagram.com/sud.psych.talks",
  city: "India",
  whatsappMessage: "Hello Sudiksha, I found your website and would like to know more about your counselling services.",
};

export const waLink = () =>
  `https://wa.me/${PRACTITIONER.whatsapp}?text=${encodeURIComponent(PRACTITIONER.whatsappMessage)}`;
